module.exports = __webpack_public_path__ + "img/glory_m.7acd33fa.png";